export const heroId = 'hero';
export const featuresId = 'features';
export const benefitsId = 'benefits';
export const testimonialsId = 'testimonials';
export const contactId = 'contact';

export const polysemeAppUrl = 'https://polyseme.app';

export const sections = [
  { id: heroId, key: 'home' },
  { id: featuresId, key: 'features' },
  { id: benefitsId, key: 'benefits' },
  { id: testimonialsId, key: 'testimonials' },
  { id: contactId, key: 'team' },
] as const;

export type SectionId = (typeof sections)[number]['id'];
